export const TENDER_AUCTION_CREATE_PAGE_PATH = '/auction/tender/create'

export const TENDER_AUCTION_LIST_PAGE_PATH = '/auction/tender/list'
